/**
 * L'ecran est-il etroit au point de demander une autre disposition ?
 *
 * UNIQUEMENT pour ce que le CSS ne sait pas faire : monter ou non un tiroir, un
 * panneau, une loupe. Tout ce qui n'est que de la mise en forme reste dans les
 * feuilles de style, sous le meme point de bascule (`@media (max-width: 640px)`),
 * pour qu'il n'y ait qu'une seule verite a maintenir.
 *
 * Le desktop ne doit RIEN voir changer : au-dessus du seuil, ce hook rend faux
 * et les composants concernes se rendent exactement comme avant.
 */
import { useEffect, useState } from 'react';

/** Doit rester d'accord avec le point de bascule des feuilles de style. */
export const COMPACT_QUERY = '(max-width: 640px)';

export function useCompact(): boolean {
  const [compact, setCompact] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(COMPACT_QUERY).matches,
  );

  useEffect(() => {
    const media = window.matchMedia(COMPACT_QUERY);
    const update = (): void => setCompact(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  return compact;
}
